
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h50v50H0z"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('use',{attrs:{"xlink:href":"#a","overflow":"visible"}})]),_c('path',{attrs:{"d":"M10 30V10h30v20H20v10H10V30zM0 50h50V0H0v50z","clip-path":"url(#b)","fill":"#e1771c"}})])
          )
        }
      }
    